import React, { useState, useEffect } from "react";
import L from "leaflet";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import MapLeftSideBar from "./MapLeftSideBar";
import MapRightSideBar from "./MapRightSideBar";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateForm, setCurrentProperty } from "../state/calculator";
import { useMediaQuery } from "react-responsive";

function MarkerMap(props) {
  const { properties, activeYearIndex } = props.redux;

  return properties.map((marker, index) => {
    const markerHtmlStyles = `background-color: green; font-size: 30px;`;
    const oneHtmlStyles = `background-color: #84AFC6; font-size: 30px;`;
    const twoHtmlStyles = `background-color: #FEDA85; font-size: 30px;`;
    const threeHtmlStyles = `background-color: #FBA94C; font-size: 30px;`;
    const fourHtmlStyles = `background-color: #BE381E; font-size: 30px;`;

    let tenYearForecast = [];
    props.redux.tenYear.map((year, indx) => {
      if (year.prop_id === marker.Prop_id) {
        tenYearForecast.push(year);
      }
    });

    let iconColor = oneHtmlStyles;

    if (tenYearForecast.length > 1) {
      if (tenYearForecast[activeYearIndex].ModelIndex === 1) {
        iconColor = oneHtmlStyles;
      } else if (tenYearForecast[activeYearIndex].ModelIndex === 2) {
        iconColor = twoHtmlStyles;
      } else if (tenYearForecast[activeYearIndex].ModelIndex === 3) {
        iconColor = threeHtmlStyles;
      } else if (tenYearForecast[activeYearIndex].ModelIndex === 4) {
        iconColor = fourHtmlStyles;
      }
    }

    const icon = new L.divIcon({
      html: `<div style="${iconColor}" /> `,
      className: "custom-marker",
    });
    let position;
    if (!marker.Lat) {
      position = [39.8283, -98.5795];
    } else {
      position = [marker.Lat, marker.Lng];
    }

    return (
      <Marker
        position={position}
        icon={icon}
        key={index}
        riseOnHover={true}
        onClick={() =>
          props.setCurrentProperty({
            prop_id: marker.Prop_id,
          })
        }
      >
        <Popup>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <img src={marker.IMG} height="200" width="200" />
            <br />
            {marker.Street}, {marker.City} {marker.GeoState}
          </div>
        </Popup>
      </Marker>
    );
  });
}

function MapBox(props) {
  const [lat, setLat] = useState(39.8283);
  const [lng, setLng] = useState(-98.5795);
  const [zoom, setZoom] = useState(10);
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1224 });
  const isMobileView = useMediaQuery({ maxDeviceWidth: 1224 });
  useEffect(() => {
    if (props.redux.properties.length > 0) {
      setLat(props.redux.properties[0].Lat);
      setLng(props.redux.properties[0].Lng);
    }
    // else if (props.redux.baseProperty.Lat) {
    //   setLat(props.redux.baseProperty.Lat);
    //   setLng(props.redux.baseProperty.Lng);
    // }
  }, [props.redux.baseProperty, props.redux.properties]);

  function handleZoom(e) {
    setZoom(e.target._zoom);
  }

  const [backgroundStyle, setBackgroundStyle] = useState(true);
  let activeBackground = {
    opacity: 0.3,
  };
  let inactiveBackground = {
    backgroundColor: "white",
  };
  useEffect(() => {
    if (typeof props.redux.currentProperty === "object") {
      setBackgroundStyle(false);
    }
  }, [props.redux.currentProperty, props.backgroundStyle]);

  return (
    <div>
      <React.Fragment>
        <div
          style={
            isMobileView
              ? { flexDirection: "column", display: "flex" }
              : { flexDirection: "row", display: "flex" }
          }
        >
          {isMobileView && (
            <div
              style={{
                display: "flex",
                minHeight: "100%",
                height: "300px",
                justifyContent: "space-evenly",
                textAlign: "center",
                minWidth: "100%",
              }}
            >
              <div id="mobileMapLeftSideBar">
                <MapLeftSideBar {...props} />
              </div>
              <div id="mobileMapRightSideBar">
                <MapRightSideBar {...props} />
              </div>
            </div>
          )}
          {!isMobileView && (
            <div id="mapLeftSideBar" style={{ borderStyle: "groove" }}>
              <MapLeftSideBar
                {...props}
                activeBackground={activeBackground}
                inactiveBackground={inactiveBackground}
                backgroundStyle={backgroundStyle}
              />
            </div>
          )}
          <div id={isMobileView ? "mobileMainMap" : "mainMap"}>
            <Map
              center={[lat, lng]}
              zoom={zoom}
              // onClick={onClickReset}
              id="map"
              onZoomEnd={handleZoom}
              className={"zoom-" + zoom}
              // onViewportChanged={this.onViewportChanged}
              // viewport={this.state.viewport}
            >
              <TileLayer
                // Default
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                // Still busy but has a nice color scheme that matches current theme
                // url="https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png"
                url="http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                // Very Gray... but kind of works?
                // url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
              <MarkerMap {...props} />
            </Map>
          </div>
          {!isMobileView && (
            <div id="mapRightSideBar" style={{ borderStyle: "groove" }}>
              <MapRightSideBar
                {...props}
                activeBackground={activeBackground}
                inactiveBackground={inactiveBackground}
                backgroundStyle={backgroundStyle}
              />
            </div>
          )}
        </div>
      </React.Fragment>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    redux: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateForm: (formData) => updateForm(formData),
      setCurrentProperty: (prop_id) => setCurrentProperty(prop_id),
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MapBox);
